import ai from '../../images/augmentedIntel.jpg';
import hand from '../../images/hand.jpg'

export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Augmented Intelligence',
  headline: 'Need that extra edge to get ahead of your competition',
  description: 'Our team has years of experience in Augmented Intelligence and the development of algorithms that can aid you in your decision making.',
  buttonLabel: 'Learn More',
  imgStart: false,
  img: ai,
  alt: 'AI',
  dark: true,
  primary: true,
  darkText: false
};

// export const homeObjTwo = {
//   id: 'discover',
//   lightBg: true,
//   lightText: false,
//   lightTextDesc: false,
//   topLine: 'Unlimited Access',
//   headline: 'Login to your account at any time',
//   description:
//     'We have you covered no matter where you are located. All you need is an internet connection and a phone or computer.',
//   buttonLabel: 'Learn More',
//   imgStart: true,
//   img: require('../../images/svg-2.svg'),
//   alt: 'Piggybank',
//   dark: false,
//   primary: false,
//   darkText: true
// };

export const homeObjThree = {
  id: 'GetStarted',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Get Started',
  headline: 'Build your crew today',
  description:
    "These tools are meant to give you a competitive advantage, they are not meant to guarantee you a win. In fact, we encourage you not to gamble. Cash Crew is not liable for any losses or damages caused are assumed to be caused by any information or content provided by Cash Crew. These algorithms are only as good as those using them, please gamble responsibly. If you or someone you know has a gambling problem, crisis counseling and referral services can be accessed by calling 1-800-GAMBLER (1-800-426-2537).",
  buttonLabel: 'Crew Builder',
  imgStart: false,
  img: hand,
  alt: 'Other',
  dark: true,
  primary: true,
  darkText: false
};
